

define(['jquery', 'squid/index', 'text!./template.html'], function ($, squid, template) {

    return squid.module('xo-member-sepa.sepaMandate.directive', ['squid']).directive('xoSepaMandate', function () {
        return {
            template: template,

            scope: {
                token: '=',
                sepa: '=',
                parentCallbacks: '='
            },

            controller: function controller($scope) {
                $('body').addClass('pageSepaMandateContingency');

                $scope.$on('$destroy', function () {
                    $('body').removeClass('pageSepaMandateContingency');
                });

                $scope.onSubmit = function () {
                    $scope.parentCallbacks.sepaAccept();
                };
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/member-sepa/sepaMandate/directive.js
 ** module id = 440
 ** module chunks = 1
 **/